import React from 'react';
import Select from '../../../../../components/shared/Select/Select';

interface TravelStyleSelectorProps {
  value?: string;
  onChange?: (value: string) => void;
  id?: string;
}

const travelStyleOptions = [
  { value: 'budget', label: 'Budget Traveler' },
  { value: 'comfort', label: 'Comfort Seeker' },
  { value: 'luxury', label: 'Luxury Explorer' },
  { value: 'adventure', label: 'Adventure Seeker' },
  { value: 'cultural', label: 'Cultural Enthusiast' },
];

const TravelStyleSelector: React.FC<TravelStyleSelectorProps> = ({ value, onChange, id = 'travelStyle' }) => {
  return (
    <Select
      label="Preferred Travel Style"
      id={id}
      value={value}
      options={travelStyleOptions}
      onChange={onChange}
      className="setting-select"
    />
  );
};

export default TravelStyleSelector;
